import {
    Component, ContentChild, ElementRef, HostBinding, HostListener, Input, OnInit, ViewChild,
} from '@angular/core';
import { MatAutocompleteOrigin } from '@angular/material/autocomplete';
import { MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
    ExtendFormControlNameDirective,
} from 'app/utils/validator/extend-form-control-name.directive';


@Component({
    selector: 'cl-text-input',
    template: `
        <div class="cl-field" #clField>
            <div class="cl-field-prefix">
                <ng-content select="[matPrefix]"></ng-content>
            </div>
            <div class="cl-field-middle">
                <div class="cl-field-outline-label">
                    <div class="cl-field-outline-label-text">
                        <label *ngIf="matLabel"
                               [attr.for]="matInput.id" [attr.aria-owns]="matInput.id">
                            <ng-content select="mat-label"></ng-content>
                        </label>
                    </div>
                    <div class="cl-field-outline-label-rest"></div>
                </div>
                <div class="cl-field-input">
                    <ng-content></ng-content>
                </div>
            </div>
            <div class="cl-field-suffix">
                <ng-content select="[matSuffix]"></ng-content>
            </div>
        </div>
        <div class="cl-field-error-container">
            <i360-error *ngIf="i360Errors && error" [control]="matInput.ngControl"></i360-error>
        </div>
    `,
    styleUrls: ['text-input.component.scss'],
})
export class TextInputComponent extends MatAutocompleteOrigin implements OnInit {
    @ContentChild(MatLabel, {static: true}) matLabel: MatLabel;  // just for ngIf
    @ContentChild(MatInput, {static: true}) matInput: MatInput;
    // from MatAutocompleteOrigin
    @ViewChild('clField', {static: true}) elementRef: ElementRef<HTMLDivElement>;
    @ContentChild(ExtendFormControlNameDirective, {static: true})
    extendedControl: ExtendFormControlNameDirective;

    @Input() i360Errors: boolean = true;
    @Input() spaceForError = true;
    @HostBinding('class.cl-can-have-error') get reserveSpaceForError() {
        return this.spaceForError && this.i360Errors;
    }

    @HostBinding('class.cl-error') get error() {
        return this.matInput && this.matInput.ngControl
            && this.matInput.ngControl.dirty && this.matInput.ngControl.invalid;
    }
    @HostBinding('class.cl-focused') get focused() {
        return this.matInput && this.matInput.focused;
    }
    @HostBinding('class.cl-should-float') get shouldLabelFloat() {
        return this.matInput && this.matInput.shouldLabelFloat;
    }
    @HostBinding('class.cl-disabled') get disabled() {
        return this.matInput && this.matInput.disabled;
    }
    @HostListener('click', ['$event']) focus(event) {
        // prevent MatAutocomplete from closing onStable due to a click event outside the input
        event.stopPropagation();
        this.matInput.focus();
    }
    constructor() {
        super(null as any);
    }
    ngOnInit(): void {
        if (this.extendedControl) {
            // present only if use formControlName
            this.extendedControl.i360Errors = false;
        }
    }
}
